/**
 * AEPERION Gem Collection — aeperion.com index clone
 */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initHeader(root) {
    var header = $('[data-gc-header]', root);
    if (!header) return;
    function onScroll() {
      header.classList.toggle('-scrolled', window.scrollY > 8);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initHero(root) {
    var hero = $('[data-gc-hero]', root);
    if (!hero) return;
    var slides = $$('[data-gc-hero-slide]', hero);
    var dots = $$('[data-gc-hero-dot]', hero);
    if (!slides.length) return;

    var index = 0;
    var timer = 0;
    var speed = parseInt(hero.getAttribute('data-autoplay-speed') || '3', 10) * 1000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('-active', n === index);
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('-active', n === index);
      });
    }

    function next() {
      show(index + 1);
    }

    function start() {
      stop();
      timer = window.setInterval(next, speed);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = 0;
    }

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        show(n);
        start();
      });
    });

    show(0);
    start();
  }

  function initCardGalleries(root) {
    $$('[data-gc-card-gallery]', root).forEach(function (gallery) {
      var imgs = $$('[data-gc-card-img]', gallery);
      var prev = $('[data-gc-card-prev]', gallery);
      var next = $('[data-gc-card-next]', gallery);
      if (imgs.length < 2) return;

      var idx = 0;
      function render() {
        imgs.forEach(function (img, n) {
          img.hidden = n !== idx;
        });
      }
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          idx = (idx - 1 + imgs.length) % imgs.length;
          render();
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          idx = (idx + 1) % imgs.length;
          render();
        });
      }
      render();
    });
  }

  function initFeatured(root) {
    var block = $('[data-gc-featured]', root);
    if (!block) return;
    var imgs = $$('[data-gc-featured-img]', block);
    var prev = $('[data-gc-featured-prev]', block);
    var next = $('[data-gc-featured-next]', block);
    if (!imgs.length) return;

    var idx = 0;
    function render() {
      imgs.forEach(function (img, n) {
        img.hidden = n !== idx;
      });
    }
    if (prev) {
      prev.addEventListener('click', function () {
        idx = (idx - 1 + imgs.length) % imgs.length;
        render();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        idx = (idx + 1) % imgs.length;
        render();
      });
    }
    render();

    var form = $('[data-gc-featured-form]', block);
    if (!form) return;
    var variantInputs = $$('input[name="id"]', form);
    var radios = $$('[data-gc-variant-radio]', form);
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var id = radio.value;
        variantInputs.forEach(function (input) {
          input.value = id;
        });
      });
    });

    var qtyInput = $('[data-gc-qty]', form);
    var minus = $('[data-gc-qty-minus]', form);
    var plus = $('[data-gc-qty-plus]', form);
    if (minus && qtyInput) {
      minus.addEventListener('click', function () {
        var v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        qtyInput.value = v;
      });
    }
    if (plus && qtyInput) {
      plus.addEventListener('click', function () {
        var v = Math.max(1, parseInt(qtyInput.value, 10) + 1);
        qtyInput.value = v;
      });
    }
  }

  function initSplit(root) {
    var split = $('[data-gc-split]', root);
    if (!split) return;
    var track = $('[data-gc-split-track]', split);
    var slides = $$('[data-gc-split-slide]', split);
    var dots = $$('[data-gc-split-dot]', split);
    if (!track || !slides.length) return;

    var index = 0;
    var timer = 0;
    var speed = parseInt(split.getAttribute('data-autoplay-speed') || '3', 10) * 1000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, n) {
        d.classList.toggle('-active', n === index);
      });
    }

    function next() {
      show(index + 1);
    }

    function start() {
      stop();
      timer = window.setInterval(next, speed);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = 0;
    }

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        show(n);
        start();
      });
    });

    show(0);
    start();
  }

  function boot() {
    $$('[data-aep-gc-page]').forEach(function (root) {
      document.documentElement.classList.add('-loaded', '-ready');
      document.body.classList.remove('-imagine-possible');
      document.body.style.overflow = '';
      initHeader(root);
      initHero(root);
      initCardGalleries(root);
      initFeatured(root);
      initSplit(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
